import React, { Dispatch } from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "../../../../../../../core/actions/configurator-actions";
import { IStore } from "../../../../../../../core/store";
import { strings } from "../../../../../../../localization/strings";
import { ParameterItem } from "../../../../components/ParameterItem";
import { IIdentificationScannerConfig } from "@piceasoft/core";
import { IIdentificationScannerConfigUI } from "@piceasoft/core";
import { IdentificationModuleUISettingsPivot } from "../IdentificationModuleUISettingsPivot";

type TProps = {
    index: number
    onChangeDispatch: Dispatch<any>
}

export const ScannerUISettingsPivot: React.FC<TProps> = (props) => {
    const config = useSelector((s: IStore) => s.configurator.identification.items.find(i => i.index === props.index) as IIdentificationScannerConfig)

    return (
        <IdentificationModuleUISettingsPivot index={props.index} onChangeDispatch={props.onChangeDispatch}>
            <ParameterItem title={strings.CONSTRUCTOR.IDENTIFICATION.SCANNER.PIVOTS.UI.BUTTON_TEXT_TITLE}
                useToggle
                toggleEnabled
                toggleChecked={config.ui?.buttonText !== undefined ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.identification.editModule({
                        ...config,
                        ui: {
                            ...config.ui,
                            buttonText: config.ui?.buttonText !== undefined ? undefined : ""
                        } as IIdentificationScannerConfigUI
                    }))
                }}
                description={strings.CONSTRUCTOR.IDENTIFICATION.SCANNER.PIVOTS.UI.BUTTON_TEXT_DESCRIPTION}
                useTextField
                textFieldEnabled={config.ui?.buttonText !== undefined ? true : false}
                textFieldValue={config.ui?.buttonText}
                textFieldOnChange={(val) => props.onChangeDispatch(actionCreators.identification.editModule({
                    ...config,
                    ui: {
                        ...config.ui,
                        buttonText: val
                    } as IIdentificationScannerConfigUI
                }))}
            />
        </IdentificationModuleUISettingsPivot>

    )
}
